/**
 * @param value - The number to format.
 * @param currencySymbol - The currency symbol to append (optional).
 * @returns The formatted currency string in Slovak locale.
 */

export const formatCurrency = (
  value: number | string,
  trim?: boolean,
  currencySymbol: string = "€"
): string => {
  let numericValue: number;

  if (typeof value === "number") {
    numericValue = value;
  } else {
    numericValue = parseFloat(value.replace(",", "."));
  }

  if (isNaN(numericValue)) return "";

  const formatted = numericValue.toFixed(2);

  if (trim === true && formatted.endsWith(".00")) {
    return `${Math.trunc(numericValue)} ${currencySymbol}`;
  }

  return `${formatted.replace(".", ",")} ${currencySymbol}`;
};
